import { Component, OnInit, OnDestroy } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { AuthService } from "../../services/auth.service";
import { ActivatedRoute, Router, Params } from "@angular/router";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

import { IResetPassword } from "../../interfaces/iresetpassword";
import { ResetPasswordService } from "../../services/resetpassword.service";
import { BusinessFunctionService } from "../../services/businessfunction.service";
import { PasswordMatcher } from "../../validators/passwordmatcher.validator";

@Component({
    selector: "resetpassword",
    templateUrl: "./resetpassword.component.html",
    standalone: false
})
export class ResetPasswordComponent implements OnInit, OnDestroy {
    displayName!: string;
    defaultRoute!: string;
    userToken!: string;
    passwordResetForm!: FormGroup;
    resettingPassword: boolean = false;
    private destroy$ = new Subject<void>();

    constructor(private router: Router,
        private activatedRoute: ActivatedRoute,
        private authService: AuthService,
        private toastr: ToastrService,
        private resetPasswordService: ResetPasswordService,
        private businessFunctionService: BusinessFunctionService) {
    }

    ngOnInit(): void {
        this.authService.accessToken = null as any;
        this.activatedRoute.queryParams
            .pipe(takeUntil(this.destroy$))
            .subscribe((params: Params) => {
                this.userToken = params['token'];
                let businessFunctionId: number = params['businessFunctionId'] as number;
                this.businessFunctionService.getBusinessFunction(businessFunctionId)
                    .pipe(takeUntil(this.destroy$))
                    .subscribe(i => {
                        this.displayName = i.displayName,
                            this.defaultRoute = i.defaultRoute;
                    });
            });

        this.passwordResetForm = new FormGroup({
            email: new FormControl("", [Validators.required]),
            password: new FormControl("", [Validators.required]),
            confirmPassword: new FormControl("", [Validators.required]),
        }, PasswordMatcher);

    }

    resetPasswordClicked(form: IResetPassword): void {
        form.token = this.userToken;
        this.resettingPassword = false;
        this.resetPasswordService.reset(form)
            .pipe(takeUntil(this.destroy$))
            .subscribe(i => {
                if (i) {
                    this.resettingPassword = true;
                    this.toastr.success("Password has successfully been reset");
                    this.router.navigate([`/${this.defaultRoute}/logon`]);
                }
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}